import { Component, Prop, State, Event, Method, EventEmitter, h } from '@stencil/core';
import { Alert } from '../../public-interfaces';

/**
 * Wraps around the entire application providing slots for layout components.
 * Has 3 sections/slots: 'header', 'nav' and 'content'.
 * @slot header - Full width, fixed height top bar.
 * @slot nav - Fixed width, full height navigation menu.
 * @slot content - Dynamically sized container for main application content.
 */
@Component({
  tag: 'layout-wrapper',
  styleUrl: 'layout-wrapper.css',
  shadow: true,
})
export class LayoutWrapper {
  /**
   * Shows a loading skeleton in the 'content' slot while this flag is set to true, otherwise displays slotted element.
   */
  @Prop() isLoading: boolean = true;

  @State() alerts: Alert[] = [];

  @Event({
    bubbles: true,
    cancelable: true,
    composed: true,
  })
  alertEmitter: EventEmitter<Alert>;
  @Method()
  async triggerAlert(newAlert: Alert) {
    this.alertEmitter.emit(newAlert);
  }

  render() {
    return (
      <main>
        <alert-box></alert-box>

        <slot name="header"></slot>
        <section>
          <slot name="nav"></slot>
          <div id="contentWrapper">{this.isLoading ? <loading-skeleton></loading-skeleton> : <slot name="content"></slot>}</div>
        </section>
      </main>
    );
  }
}
